// The price guide's sums (EstimatorSection): display only, never stored or
// charged (WEB_V2_BUILD.md §0 finance line). Pure, for tests/estimator.test.js.
//
// A row is a slider {label, kind:'slider', min, max, step, start, rate, unit}
// (adds value × rate) or a choice {label, kind:'choice', options:[{label, add}]}
// (adds the picked option's amount). The studio's generic {label, value} rows
// read as a slider from 1 to 10 at `value` per unit.

const num = (v, d = 0) => (Number.isFinite(Number(v)) ? Number(v) : d);

export function estimatorRows(rows) {
    return (Array.isArray(rows) ? rows : []).filter((r) => r && r.label).slice(0, 4).map((r) => {
        if (Array.isArray(r.options) && r.options.length) {
            return {label: String(r.label), kind: "choice", options: r.options.filter((o) => o && o.label).map((o) => ({label: String(o.label), add: num(o.add)})), start: 0};
        }
        const min = num(r.min, 1);
        const max = Math.max(min, num(r.max, 10));
        const step = num(r.step, 1) > 0 ? num(r.step, 1) : 1;
        const start = Math.min(max, Math.max(min, num(r.start ?? r.default, min)));
        return {label: String(r.label), kind: "slider", min, max, step, start, rate: num(r.rate ?? r.value), unit: r.unit || ""};
    });
}

export function estimateFrom(base, rows, values) {
    let total = num(base);
    rows.forEach((r, i) => {
        const v = values?.[i];
        if (r.kind === "choice") total += num(r.options[num(v)]?.add);
        else total += num(v, r.start) * r.rate;
    });
    return Math.max(0, Math.round(total));
}
